import type { filtersType } from '../../../components/v2/filters/interfaces'

export const getFilters = ({
  currentFilters,
  availableFilters,
  isGoLeader,
  isBrandLeader,
}): filtersType[] => {
  const general: filtersType[] = [
    {
      name: 'id',
      label: 'ID клиента',
      placeholder: 'Найти клиента',
      prefix: 'ID',
      type: 'input-integer',
      value: currentFilters.id || undefined,
      options: {
        width: '170px',
      },
    },
    {
      name: 'fio',
      label: 'Контактное лицо',
      placeholder: 'Контактное лицо',
      type: 'input-string',
      value: currentFilters.fio || undefined,
    },
    {
      name: 'production_number',
      label: 'Номер производственного заказа',
      placeholder: 'Номер производственного заказа',
      type: 'input-string',
      value: currentFilters.production_number || undefined,
    },
    {
      name: 'additional',
      label: 'Доп контакты',
      placeholder: 'Доп контакты',
      type: 'input-string',
      value: currentFilters.additional || undefined,
    },
    {
      name: 'phone',
      label: 'Телефон клиента',
      placeholder: 'Телефон клиента',
      type: 'phone',
      value: currentFilters.phone || undefined,
    },
  ]

  const leader: filtersType[] = [
    {
      name: 'office',
      label: 'Офис',
      placeholder: 'Офис',
      type: 'select',
      value: currentFilters.office || undefined,
      options: {
        enum: availableFilters?.offices || [],
      },
    },
  ]

  const goLeaderFilters: filtersType[] = [
    {
      name: 'brand',
      label: 'Бренд',
      placeholder: 'Бренд',
      type: 'select',
      value: currentFilters.brand || undefined,
      options: {
        enum: availableFilters?.brands || [],
      },
    },
    {
      name: 'organization',
      label: 'Организация',
      placeholder: 'Организация',
      type: 'select',
      value: currentFilters.organization || undefined,
      options: {
        enum: availableFilters?.organizations || [],
      },
    },
    {
      name: 'dates',
      label: 'Диапазон дат',
      type: 'dates',
      value: currentFilters.dates || undefined,
    },
  ]

  if (isGoLeader) {
    return [...general, ...leader, ...goLeaderFilters]
  }
  if (isBrandLeader) {
    return [...general, ...leader]
  }
  return general
}
